/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-const */
/* eslint-disable no-shadow */
/* eslint-disable react/no-this-in-sfc */
import React, { useState, useEffect, useRef, useCallback, useLayoutEffect } from 'react'
import { message, Radio } from 'antd'
import classNames from 'classnames'
import Input from 'meinian-package/src/baseComponent/input'
import Modal from 'meinian-package/src/baseComponent/modal'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import Icon from 'meinian-package/src/component/icon'
import Textarea from 'meinian-package/src/component/textarea'
import mes from 'meinian-package/src/utils/message'
import request from 'meinian-package/src/utils/request'
import { isPermissions } from 'meinian-package/src//utils/auth'
import { Loading } from 'meinian-package/src/baseComponent'
import Button from 'meinian-package/src/baseComponent/button'
import TagList from 'meinian-package/src/component/imageDetail/tagSelection'
import { AttrFactory } from 'meinian-package/src/component/imageDetail/attrFactory'
import { StyleSelect, MnInputNum } from 'meinian-package/src/component/imageDetail/styleSelect'
import { getIpadVh } from 'common/ipad'
import userInfo, { getTeamInfo } from 'meinian-package/src/common/userInfo'
import { GENDER_OPTIONS,
  PLATFORM_VALUE, } from 'meinian-package/src/component/enum'
import { STYLE_PLAN, STYLE_PLAN_TEXT, STYLE_TYPE, STYLE_TYPE_TEXT } from 'common/config/enum'
import { ImageGallery, useUpgradeInfo } from './upgrade.common'
import './upgradeModal.less'
import GoodsInfoBox from './upgrade.goods'
import UserDefinedProps, { TYPE } from './userDefinedProps'

const DESIGN_TITLE = [
  {
    index: 0,
    title: '款式图库',
    id: '#gallery'
  },
  {
    index: 1,
    title: '款式信息',
    id: '#info'
  },
  {
    index: 3,
    title: '款式属性',
    id: '#attribute'
  },
  {
    index: 4,
    title: '关联信息',
    id: '#associated'
  }
]

const dealAttr = (attrVal) => {
  if (attrVal instanceof Array) {
    return [...attrVal]
  }
  if (attrVal instanceof Set) {
    return Array.from(attrVal)
  }
  if (attrVal == null || attrVal == undefined || attrVal == 'null') {
    return []
  }
  return [attrVal]
}

export default (props) => {
  const {
    currentImage,
    inspirationId,
    onDeleteItem,
    blogId,
    noAuth,
    children,
    onChange,
    style,
    boxIndex,
    propIndex,
    setBanStatus,
    onClose
  } = props
  const [visible, setVisible] = useState(false)
  const onClick = () => {
    if (noAuth) {
      message.error('没有操作权限')
      return
    }
    setVisible(true)
  }

  useEffect(() => {
    if (visible) {
      setBanStatus?.(true)
    } else {
      setBanStatus?.(false)
    }
  }, [visible])

  return <>
    <span onClick={onClick} style={style}>{children || '升级款式'}</span>
    {visible ? <UpgradeModal
      visible={visible}
      setVisible={setVisible}
      currentImage={currentImage}
      onClose={onClose}
      inspirationId={inspirationId}
      blogId={blogId}
      onDeleteItem={onDeleteItem}
      onChange={onChange}
      boxIndex={boxIndex}
      propIndex={propIndex}
    /> : null}
  </>
}
export const UpgradeModal = (props) => {
  const {
    visible,
    setVisible,
    currentImage,
    onClose,
    inspirationId,
    blogId,
    onDeleteItem,
    onChange,
    boxIndex,
    propIndex = 0
  } = props
  const accountInfo = userInfo
  const teamInfo = getTeamInfo()
  const elements = (currentImage?.boxLabelRetList && currentImage?.boxLabelRetList[boxIndex]) || {}
  const { style, texture, technology, rootFabric, fabric, accessories, contour, collar, vamp, element, process, sole } = elements
  const finalElements = { texture, technology, fabric, accessories, contour, collar, vamp, element, process, sole, style }
  const hasElements = texture || technology || rootFabric || fabric || accessories || vamp || element || process || sole
  const showSmartTags = style || hasElements
  const auth = currentImage?.loginUserInfo?.inspirationPermissions || []
  const current = currentImage || {}
  const [tags, setTags] = useState([])
  const [colorList, setColorList] = useState([])
  const [goods, setGoods] = useState([])
  const [goodIds, setGoodIds] = useState(new Set())
  const [blogGalleryList, setBlogGalleryList] = useState([])
  const [industryAtrr, setIndustryAtrr] = useState([])
  const [upgradeInfo, setUpgradeInfo, reload, loading] = useUpgradeInfo(inspirationId, blogId)
  const [propertyValueParamList, setPropertyValueParamList] = useState([])
  const [switchGender, setSwitchGender] = useState(false)
  const [industryLoading, setindustryLoading] = useState(true)
  const [warn, setWarn] = useState(false)
  const [titleIndex, setTitleIndex] = useState(propIndex)
  // 用于页面滑动
  const $container = useRef()
  const $design = useRef()
  const $gallery = useRef()
  const $info = useRef()
  const $trait = useRef()
  const $attribute = useRef()
  const $associated = useRef()
  // 用于页面尺寸变化
  const $titleContent = useRef()
  const $designContent = useRef()
  let infoTop = $info.current?.offsetTop
  let traitTop = $trait.current?.offsetTop
  let attributeTop = $attribute.current?.offsetTop
  let associatedTop = $associated.current?.offsetTop

  const handScroll = useCallback((e) => {
    infoTop = $info.current?.offsetTop
    traitTop = $trait.current?.offsetTop
    attributeTop = $attribute.current?.offsetTop
    associatedTop = $associated.current?.offsetTop
    if (e.target.scrollTop < infoTop) {
      setTitleIndex(0)
    } else if (e.target.scrollTop < traitTop) {
      setTitleIndex(1)
    } else if (e.target.scrollTop < attributeTop) {
      setTitleIndex(2)
    } else if (e.target.scrollTop < associatedTop) {
      setTitleIndex(3)
    }
  })
  useEffect(() => {
    $container.current?.addEventListener('scroll', handScroll)
    return () => $container.current?.removeEventListener('scroll', handScroll)
  }, [handScroll])

  const handResize = useCallback((e) => {
    if ($titleContent.current && $designContent.current) {
      $titleContent.current.style.left = `${(e.target.innerWidth - 890) / 2}px`
      $designContent.current.style.right = `${(e.target.innerWidth - 890) / 2}px`
    }
  })
  useEffect(() => {
    window.addEventListener('resize', handResize)
    return () => window.removeEventListener('resize', handResize)
  }, [])

  useEffect(() => {
    if (upgradeInfo?.blogGalleryImageList?.length) {
      let imgs = upgradeInfo?.blogGalleryImageList.map(item => ({
        ...item,
        mainUrl: item.childMainUrl,
        imageGroupIndex: item.childEntityIndex
      }))
      setBlogGalleryList([...imgs].filter(Boolean))
    }
  }, [upgradeInfo.blogGalleryImageList])

  useLayoutEffect(() => {
    if (loading) return
    setTimeout(() => {
      if (propIndex === 1) {
        document.getElementById('info')?.scrollIntoView()
      }
      if (propIndex === 2) {
        document.getElementById('trait')?.scrollIntoView()
      }
      if (propIndex === 3) {
        document.getElementById('attribute')?.scrollIntoView()
      }
      if (propIndex === 4) {
        document.getElementById('associated')?.scrollIntoView()
      }
    }, 300)
  }, [loading])

  useEffect(() => {
    let newData = []
    if (!switchGender && industryAtrr.length > 0) {
      const convertIndustry = convertData(industryAtrr)
      if (upgradeInfo?.propertyValueDTOList?.length > 0) {
        const dtoList = upgradeInfo.propertyValueDTOList
        const newIndustry = mergeData(convertIndustry, dtoList)
        if (propertyValueParamList?.length > 0) {
          const mergeParamList = mergeData(newIndustry, propertyValueParamList)
          newData = mergeParamList
        } else {
          newData = newIndustry
        }
      } else if (propertyValueParamList?.length > 0) {
        const mergeParamList = mergeData(convertIndustry, propertyValueParamList)
        newData = mergeParamList
      } else {
        newData = convertIndustry
      }
    }
    if (switchGender) {
      const convertIndustry = convertData(industryAtrr)
      if (propertyValueParamList?.length > 0) {
        const mergeParamList = mergeData(convertIndustry, propertyValueParamList)
        newData = mergeParamList
      } else {
        newData = convertIndustry
      }
    }

    if (newData) { // 单独处理 级联 删除了设置的选项则需要过滤掉 values
      const filterPropertyValueList = newData?.map((item) => {
        if (industryAtrr.length) {
          if (industryAtrr.find(arr => arr.propertyId === item.id) !== -1) {
            let findItem = industryAtrr.find(arr => arr.propertyId === item.propertyId)
            if (findItem?.propertyType === TYPE.MULTIPLE) {
              item.values = item.values.filter(it => {
                return isFindItem(findItem?.multiStruct?.rootItems, it.split('^'))
              })
            }
          }
        }
        return item
      })
      setPropertyValueParamList([...filterPropertyValueList])
    } else {
      setPropertyValueParamList([])
    }
  }, [industryAtrr, upgradeInfo.propertyValueDTOList])

  const isFindItem = (data, val) => {
    let is = false
    if (data?.length === 0) {
      return false
    }
    data.forEach(item => {
      if (val.includes(item.value)) {
        is = true
      }
      if (item?.childItems?.length) {
        isFindItem(item?.childItems, val)
      }
    })
    return is
  }

  useEffect(() => {
    const sub = () => {
      fetchIndustryAtrr(upgradeInfo.gender)
    }
    mes.sub('MNDefinedProperty', sub)
    return () => { mes.remove('MNDefinedProperty', sub) }
  }, [upgradeInfo])

  useEffect(() => {
    if (upgradeInfo.goods) {
      setGoods(upgradeInfo.goods)
    }
  }, [upgradeInfo.goods])

  useEffect(() => {
    if (visible) {
      request.get(`/zhikuan/img-tag/list-img-tag?entityId=${blogId}`).then((res) => {
        setTags(res.map(m => m.tagName))
      })
      reload()
    }
  }, [visible])

  useEffect(() => {
    if (upgradeInfo.color) {
      setColorList(JSON.parse(upgradeInfo.color))
    }
  }, [upgradeInfo.color])
  useEffect(() => {
    if (upgradeInfo.itemIdList) {
      // eslint-disable-next-line radix
      setGoodIds(new Set(upgradeInfo?.itemIdList?.map(m => parseInt(m))))
    }
  }, [upgradeInfo.itemIdList])
  useEffect(() => {
    if (upgradeInfo.gender) {
      fetchIndustryAtrr(upgradeInfo.gender)
    }
  }, [upgradeInfo.gender])

  const fetchIndustryAtrr = async (gender) => {
    if (!gender) return
    setindustryLoading(true)
    try {
      const res = await request.get(`/zhikuan/mn/property/list?targetType=1&gender=${gender}`)
      setIndustryAtrr(res)
    } catch (err) {
      console.error(err)
    }
    setindustryLoading(false)
  }

  const convertData = (data) => {
    if (data?.length > 0) {
      const visibleData = data.filter(item => item.isVisible)
      return visibleData.map((item) => {
        return {
          propertyId: item.propertyId,
          propertyName: item.propertyName,
          propertyType: item.propertyType,
          values: []
        }
      })
    }
    return []
  }

  const mergeData = (generalList, pointsList) => {
    for (let i = 0; i < generalList.length; i++) {
      for (let j = 0; j < pointsList.length; j++) {
        if (generalList[i].propertyId == pointsList[j].propertyId) {
          generalList[i] = pointsList[j]
        }
      }
    }
    return generalList
  }

  const onColorsChange = (value) => {
    setColorList(value)
  }

  const onTagsChange = (value) => {
    setTags(value)
  }

  const onGenderChange = (value) => {
    if (upgradeInfo.gender && value != upgradeInfo.gender) {
      ModalConfirm.show({
        title: '确认更换行业？',
        content: '更换行业后将清空现有款式属性',
        onOk: () => {
          onChangeParams({ gender: value })
          setSwitchGender(true)
        }
      })
    } else {
      onChangeParams({ gender: value })
    }
  }

  const onTitleChange = (index) => {
    setTitleIndex(index)
    if (index == 0) {
      $container.current.scrollTop = 0
    }
    if (index == 1) {
      document.getElementById('info')?.scrollIntoView()
    }
    if (index == 2) {
      document.getElementById('trait')?.scrollIntoView()
    }
    if (index == 3) {
      document.getElementById('attribute')?.scrollIntoView()
    }
    if (index == 4) {
      document.getElementById('associated')?.scrollIntoView()
    }
  }
  const onSubmit = async () => {
    const { accessories, category, fabric, gender, relatedInspirationUrl,
      style, styleDesc, stylePlan, styleTitle, styleType, season, size, price } = upgradeInfo
    if (relatedInspirationUrl && !/^http[s]*:\/\//.test(relatedInspirationUrl)) { message.error('请输入正确的链接'); return }
    // 提交时将文本标签存本地
    const localColorList = JSON.parse(window.localStorage.getItem('mnEditImageColors'))
    let coverColorList
    let lastColorList
    if (localColorList?.length > 0) {
      coverColorList = new Set(localColorList.concat([...colorList]))
    } else {
      coverColorList = colorList
    }
    lastColorList = new Set(Array.from(coverColorList).reverse().slice(0, 20))
    window.localStorage.setItem('mnEditImageColors', JSON.stringify(Array.from(lastColorList)))
    // 将保存的属性值保存到本地
    if (propertyValueParamList?.length > 0) {
      const hyperlinks = propertyValueParamList.filter(m => m.propertyType === 4)
      if (hyperlinks?.length > 0) {
        for (let i = 0; i < hyperlinks.length; i++) {
          if (hyperlinks[i].values != '' && !/^http[s]*:\/\//.test(hyperlinks[i].values)) {
            return message.error('请输入正确的链接')
          }
        }
      }
      // 读取之前存储的params信息
      const result = window.localStorage.getItem('mnEditImageParams')
      const newLocalParams = propertyValueParamList.filter(m => m.propertyType === 1 || m.propertyType === 2)
      const localParams = JSON.parse(JSON.stringify(newLocalParams))
      if (result) {
        const convertResult = JSON.parse(result)
        if (convertResult?.length > 0) {
          for (let i = 0; i < localParams.length; i++) {
            for (let j = 0; j < convertResult.length; j++) {
              if (convertResult[j].propertyId === localParams[i].propertyId) {
                localParams[i].values = Array.from(new Set(convertResult[j].values.concat(localParams[i].values)))
              }
            }
          }
        }
        window.localStorage.setItem('mnEditImageParams', JSON.stringify(localParams))
      } else {
        window.localStorage.setItem('mnEditImageParams', JSON.stringify(localParams))
      }
    }
    console.log('执行了么', blogGalleryList)
    const _params = {
      inspirationId,
      entityId: blogId,
      styleTitle,
      styleDesc,
      blogGalleryList: blogGalleryList.map(m => ({
        childEntityId: m.childEntityId,
        childEntityIndex: m.imageGroupIndex,
        childMainUrl: m.mainUrl,
        childPlatformId: m.childPlatformId
      })),
      mainUrl: blogGalleryList[0].mainUrl,
      itemIdList: [...goodIds.values()],
      tagNameList: [...tags.values()],
      gender,
      category,
      season,
      stylePlan,
      styleType,
      style,
      fabric,
      accessories,
      relatedInspirationUrl,
      color: [...colorList],
      size,
      price,
      propertyValueParamList
    }
    await request.post('/zhikuan/ins/inspiration/add-style-info', _params)
    const NParams = { // 不懂为什么是这个结构
      ...upgradeInfo,
      imageEntityExtend: {
        styleTitle: _params.styleTitle
      },
      ..._params
    }
    onChange && onChange?.(true, NParams)
    setVisible(false)
  }

  const onChangeParams = (newParams) => {
    setUpgradeInfo(pre => ({ ...pre, ...newParams }))
  }
  const onChangePropertyValue = (id, attrVal, type, name) => {
    if (propertyValueParamList.findIndex(m => m.propertyId === id) >= 0) {
      const newPropertyValueParamList = propertyValueParamList.filter(item => item.propertyId != id)
      newPropertyValueParamList.push({ propertyId: id, values: dealAttr(attrVal), propertyType: type, propertyName: name })
      setPropertyValueParamList([...newPropertyValueParamList])
    } else {
      propertyValueParamList.push({ propertyId: id, values: dealAttr(attrVal), propertyType: type, propertyName: name })
      setPropertyValueParamList([...propertyValueParamList])
    }
  }
  const onAddGood = (good) => {
    // 如果id存在不添加
    if (goodIds.has(good.itemId)) {
      return message.warn('请勿重复添加')
    }
    goodIds.add(good.itemId)
    setGoodIds(new Set(goodIds))
    goods.push(good)
    setGoods(goods)
  }

  const onDeleteGood = (good) => {
    const tempGoodIds = [...goodIds].filter(m => m != good.itemId)
    setGoodIds(new Set(tempGoodIds))
    setGoods(goods.filter(m => m.itemId != good.itemId))
  }

  const onDelete = () => {
    if (!isPermissions(auth, ['FS03', 'FS03_CREATOR', 'FCS03', 'FCS03_CREATOR'])) {
      message.error(current.platformId === PLATFORM_VALUE.UPLOAD ? '仅能移除自己上传的图片哦' : '仅能移除自己采集的款式哦')
      return
    }
    ModalConfirm.show({
      title: '确认删除该款式？',
      content: '删除后，该款式将从当前灵感集中移除，相关的信息也将一并删除',
      onOk: async () => {
        try {
          await request.post('/ins/inspiration/remove-from-inspiration', {
            blogList: [{ blogId }],
            inspirationId
          })
          message.success('已成功删除')
          onDeleteItem()
          setVisible(false)
        } catch (err) {
          message.error('删除失败，请稍后再尝试删除。')
        }
      },
    })
  }

  const onImageGallery = (blogGalleryList) => {
    setBlogGalleryList([...blogGalleryList])
  }
  return <Modal
    style={{ width: '100vw', height: '100%', borderRadius: '0' }}
    className={classNames('meinian-update-style-modal')}
    visible={visible}
    hiddenFooter
    hiddenCloseIcon
  >
    <div className="upgrade-image-title">
      <Icon type="m-jiantou_zuo" onClick={() => { setVisible(false) }} />
      <span className="style-model-title">编辑款式</span>
    </div>
    <div className="content-container" ref={$container} style={{ height: getIpadVh() }}>
      {/* 左侧 */}
      <div className="design-title-content" ref={$titleContent} style={{ left: `${(window.innerWidth - 890) / 2}px` }}>
        {
            DESIGN_TITLE.map((item, index) => {
              return <a key={index} onClick={() => onTitleChange(index)} className={classNames('title-item', { active: index === titleIndex })}>
                <span />
                <span>{item.title}</span>
              </a>
            })
          }
      </div>
      <div className="design-info-content" ref={$design}>
        <div className="design-info" ref={$designContent} style={{ right: `${(window.innerWidth - 890) / 2}px` }}>
          <div className="header-placeholder" />
          <div id="gallery" ref={$gallery}>
            <InfoCard title="款式图库">
              <ImageGallery images={blogGalleryList} onChange={onImageGallery} />
              <i className="describe">最多可添加20张图片，拖动图片，即可调整图片在款式图库中的显示顺序</i>
            </InfoCard>
          </div>
          <div id="info" ref={$info}>
            <InfoCard title="款式信息">
              <div className="section-item">
                <span className="label">款式名称</span>
                <Input
                  placeholder="输入款式名称，比如2021夏季连衣裙"
                  wrapClassName="style-title-input"
                  withBorder
                  value={upgradeInfo.styleTitle}
                  maxLength={20}
                  showCount
                  suffix={`${upgradeInfo.styleTitle?.length || 0}/20`}
                  onChange={(e) => {
                    if (e.target.value.length >= 21) {
                      return
                    }
                    onChangeParams({ styleTitle: e.target.value })
                  }}
                  wrapStyle={{ flex: 1, paddingLeft: 16 }}
                />
              </div>
              <div className="section-item">
                <div className="label" style={{ paddingBottom: 80 }}>款式描述</div>
                <Textarea
                  placeholder="输入内容，来让自己或其他成员更好的了解款式的面料，辅料、工艺、风格、颜色及卖点"
                  wrapClassName="style-desc-textarea"
                  wrapStyle={{ paddingLeft: 16 }}
                  withBorder
                  value={upgradeInfo.styleDesc}
                  minHeight={100}
                  maxLength={200}
                  suffix={<div className="suffix">{`${upgradeInfo.styleDesc?.length || 0}/200`}</div>}
                  onInput={(e) => {
                    if (e.target.value.length >= 201) {
                      message.warning('最多支持输入200个字')
                      return
                    }
                    onChangeParams({ styleDesc: e.target.value })
                  }}
                />
              </div>
              <div className="section-item">
                <span className="label">参考价格</span>
                <MnInputNum
                  value={upgradeInfo.price || 0}
                  maxNum={10000000}
                  onChange={(value) => {
                    if (!/^\d+(.\d{1,2})?$/.test(Number(value))) {
                      return
                    }
                    if (Math.ceil(Number(value)) > 10000000) {
                      return message.warning('最多支持输入9999999.99')
                    }
                    onChangeParams({ price: value || 0 })
                  }}
                />
              </div>
              <div className={classNames('section-item', [...tags]?.length > 0 && 'alignment')}>
                <span className="label">款式标签</span>
                <TagList
                  type="fetchInterface"
                  className="style-lable-tag"
                  value={tags}
                  smartTags={finalElements}
                  showSmartTags={showSmartTags}
                  onChange={onTagsChange}
                  suffix={20}
                  overlayStyle={{ maxWidth: '575px' }}
                  style={{ width: '100%', marginBottom: 0 }}
                />
              </div>
              <div className={classNames('section-item', [...colorList]?.length > 0 && 'alignment')}>
                <span className="label">款式颜色</span>
                <TagList
                  localKey="styleColors"
                  className="style-lable-tag"
                  value={colorList}
                  onChange={onColorsChange}
                  suffix={20}
                  overlayStyle={{ maxWidth: '575px' }}
                  style={{ width: '100%', marginBottom: 0 }}
                />
              </div>
              <div className="section-item">
                <span className="label">开款计划</span>
                <Radio.Group value={upgradeInfo.stylePlan || 0} onChange={e => onChangeParams({ stylePlan: e.target.value })}>
                  <Radio value={STYLE_PLAN.YUANCHUANG}>{STYLE_PLAN_TEXT[STYLE_PLAN.YUANCHUANG]}</Radio>
                  <Radio value={STYLE_PLAN.CAIMAI}>{STYLE_PLAN_TEXT[STYLE_PLAN.CAIMAI]}</Radio>
                  <Radio value={STYLE_PLAN.COOPERATION}>{STYLE_PLAN_TEXT[STYLE_PLAN.COOPERATION]}</Radio>
                  <Radio value={STYLE_PLAN.NUM}>{STYLE_PLAN_TEXT[STYLE_PLAN.NUM]}</Radio>
                </Radio.Group>
              </div>
              <div className="section-item">
                <span className="label">款式类型</span>
                <Radio.Group value={upgradeInfo.styleType || 0} onChange={e => onChangeParams({ styleType: e.target.value })}>
                  <Radio value={STYLE_TYPE.BASED}>{STYLE_TYPE_TEXT[STYLE_TYPE.BASED]}</Radio>
                  <Radio value={STYLE_TYPE.THEME}>{STYLE_TYPE_TEXT[STYLE_TYPE.THEME]}</Radio>
                  <Radio value={STYLE_TYPE.FIGURE}>{STYLE_TYPE_TEXT[STYLE_TYPE.FIGURE]}</Radio>
                </Radio.Group>
              </div>
            </InfoCard>
          </div>
          <div id="attribute" ref={$attribute}>
            <InfoCard
              setPropertyValueParamList={setPropertyValueParamList}
              propertyValueParamList={propertyValueParamList}
              title="款式属性"
              introduce="生成样衣的时候会同步款式属性"
              isShowAttr
              gender={upgradeInfo.gender}
              accountInfo={accountInfo}
              teamInfo={teamInfo}
              setWarn={setWarn}
            >
              <div className="section-item" id="gender">
                <span className="label">所属行业</span>
                <StyleSelect
                  style={warn ? { borderColor: '#f25345' } : {}}
                  placeholder="点击选择"
                  value={upgradeInfo.gender}
                  options={GENDER_OPTIONS}
                  onChange={value => onGenderChange(value)}
                  onFocus={() => setWarn(false)}
                />
              </div>
              {!upgradeInfo.gender
                ? <PromptMessage />
                : industryLoading
                  ? <Loading spinning wrapperClassName="spin-transparent-bg"><div style={{ height: 400 }} /></Loading>
                  : <AttrFactory
                      visible={visible}
                      industryAtrr={industryAtrr || []}
                      value={[...propertyValueParamList]}
                      onChange={(id, value, type, name) => onChangePropertyValue(id, value, type, name)}
                  />}
            </InfoCard>
          </div>
          <div id="associated" ref={$associated} style={{ paddingBottom: 400 }}>
            <InfoCard title="关联信息">
              <div className="related-products">
                <div className="related-products-label">相关商品</div>
                <GoodsInfoBox value={goods} onAdd={onAddGood} onDelete={onDeleteGood} />
              </div>
              <div className="section-item">
                <span className="label">关联款式</span>
                <Input
                  placeholder="请输入关联款式链接"
                  withBorder
                  value={upgradeInfo.relatedInspirationUrl}
                  onChange={e => onChangeParams({ relatedInspirationUrl: e.target.value })}
                  maxLength={200}
                  wrapStyle={{ flex: 1 }}
                />
              </div>
            </InfoCard>
          </div>
          <div className="footer-placeholder" />
        </div>
      </div>
    </div>
    <div className="modal-footer">
      <Button type="normal" onClick={onDelete} style={{ width: 112, borderRadius: '2px' }}>删除</Button>
      <div className="meinian-space" />
      <Button
        type="normal"
        onClick={() => {
          setVisible(false)
          onClose?.()
        }}
        style={{ marginRight: 16, width: 112, borderRadius: '2px' }}
      >取消</Button>
      <Button type="primary" style={{ width: 112, borderRadius: '2px' }} onClick={onSubmit}>保存</Button>
    </div>
  </Modal>
}

const InfoCard = (props) => {
  const { title, introduce, gender, isShowAttr, accountInfo, teamInfo, onChange, setWarn, propertyValueParamList, setPropertyValueParamList } = props
  const onChangeGener = () => {
    onChange && onChange(1)
    setWarn && setWarn(true)
  }
  return <div className="info-card">
    <div className="card-title">
      <div className="title-left">
        <div className="design-title">{title}</div>
        <div className="introduce">{introduce}</div>
      </div>
      {isShowAttr && <div className="title-right">
        <a className="current-gender" onClick={onChangeGener}>
          <span>当前行业</span>
          <span>{gender}</span>
          <Icon type="m-bianji" />
        </a>
        <div className="custom-attr">
          <UserDefinedProps
            gender={gender}
            accountInfo={accountInfo}
            teamInfo={teamInfo}
            type={1}
            propertyValueParamList={propertyValueParamList}
            setPropertyValueParamList={setPropertyValueParamList}
          />
        </div>
      </div>}
    </div>
    {props.children}
  </div>
}

const PromptMessage = () => {
  return <div className="prompt-meg">
    <Icon type="m-zhuyi_tianchong" />
    <span>请先选择行业后，填写相关款式属性</span>
  </div>
}
